module.exports = __webpack_public_path__ + "img/saks2.a975c4c0.jpg";